import { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Kanban from "../../components/kanban/Kanban";
import KanbanHeader from "../../components/kanban/KanbanHeader";
import { KANBAN_PARENT_TYPE } from "../../components/kanban/kanban.constants";
import { getViewPermission } from "../../helpers/utils";



const SimpleUserDashboard = () => {
  const [projectId, setProjectId] = useState(null);
  const [scopeId, setScopeId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [onCreateTask, setOnCreateTask] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!getViewPermission("task")) {
      history.push("/timesheet");
    }
    else {
      setIsRender(true);
    }
  }, []);

const handleProjectChange = useCallback((id) => {
  setProjectId(id);
  setScopeId(null);
}, []);

const handleScopeChange = useCallback((id) => {
  setScopeId(id);
}, []);

const getKanbanProps = useCallback(() => {
  if (scopeId) {
    return { parent: KANBAN_PARENT_TYPE.SCOPE, parentId: scopeId };
  }
  if (projectId) {
    return { parent: KANBAN_PARENT_TYPE.PROJECT, parentId: projectId };
  }
  return { parent: KANBAN_PARENT_TYPE.NONE, parentId: null };
}, [projectId, scopeId]);

const kanbanProps = getKanbanProps();

return (
  isRender &&
  <>
    <KanbanHeader
      onProjectChange={handleProjectChange}
      onScopeChange={handleScopeChange}
      onSearch={setSearchTerm}
      onCreateTask={setOnCreateTask}
    />
    <Kanban
      key={`${kanbanProps.parent}-${kanbanProps.parentId || "all"}`}
      parent={kanbanProps.parent}
      parentId={kanbanProps.parentId}
      searchTerm={searchTerm}
      heightDelta="170px"
      onCreateTask={onCreateTask}
      setOnCreateTask={setOnCreateTask}

    />
  </>
);
};

export default SimpleUserDashboard;